import { render, staticRenderFns } from "./riskOrders.vue?vue&type=template&id=5bd4e365&scoped=true"
import script from "./riskOrders.vue?vue&type=script&lang=js"
export * from "./riskOrders.vue?vue&type=script&lang=js"
import style0 from "./riskOrders.vue?vue&type=style&index=0&id=5bd4e365&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4e365",
  null
  
)

export default component.exports